import React from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Page Components
import Home from './components/Home';
import About from './components/About';
import ConnectWithUs from './components/ConnectWithUs';
import Mainpage from './components/Mainpage';
import Card from './components/Card';
import Modal from './components/Modal';
import Signup from './components/Signup';
import Login from './components/Login';
import Bookstore from './components/Bookstore';

// Context
import { useAuth } from './components/AuthContext'; 

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  // 1. Always call the hook at the top level (Never return anything before this)
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/signup', element: <Signup /> },
    { path: '/login', element: <Login /> },
    { path: '/about', element: <About /> },
    { path: '/connect-with-us', element: <ConnectWithUs /> },
    { path: '/mainpage', element: <Mainpage /> },
    { path: '/card', element: <Card /> },
    { path: '/modal', element: <Modal /> },
    { 
      path: '/bookstore',
      element: isAuthenticated ? <Bookstore /> : <Navigate to="/login" replace />
    },
    { path: '*', element: <div style={{ padding: "50px", textAlign: "center" }}><h1>404: Page Not Found</h1></div> },
  ]);

  // 2. Handle the loading state AFTER the hook has been called
  if (isLoading) {
    return (
      <div style={{ padding: "50px", textAlign: "center" }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return routes;
}

function App() {
  return (
    <div className="app-container">
      <Navbar />
      <main className="content">
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

export default App;